import { BillingRetentionModelType } from '@teinor/erp/types/company/config/billingGroup/billingRetention'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ModalCEConfigBillingRetention from './ModalCEBillingRetention'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderString, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'



interface ConfigBillingRetentionsProps extends ComponentWithPermissions { }

const ConfigBillingRetentions: React.FC<ConfigBillingRetentionsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('typeRetentions', 'Tipos de Retención'),
        newText: t('newTypeRetention', 'Nuevo Tipo de Retención'),
    }

    return (
        <BaseScreenTable TableComponent={TableBillingRetentions} CreateModalComponent={ModalCEConfigBillingRetention} EditModalComponent={ModalCEConfigBillingRetention} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableBillingRetentionsProps extends TableComponentProps {}

const TableBillingRetentions: React.FC<TableBillingRetentionsProps> = ({ userPermissions, setTableInstance, setOpened }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId } = useParams()


    const columns: ColumnTableSchema<BillingRetentionModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'retention',
            dataKey: 'retention',
            label: t('retention', 'Retención'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue + ' %'} />,
            sortable: true,
            width:100
        },
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Clave'),
            sortable: true,
            width: 100
        },
        {
            id: 'model',
            dataKey: 'model',
            label: t('model', 'Modelo'),
            sortable: true,
            width: 100
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
    ]
    return (
        <TwinTable name='billingRetentions' columns={columns} getDataFrom='/api/app/config/billingGroup/billingRetention/getAllBillingRetentions' extraWhereParams={{ BillingGroupId }} setTableInstance={setTableInstance} defaultOrder={{defaultOrderField: 'id', order: 'asc'}}onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} />
    )
}


export default ConfigBillingRetentions